<template>


    <div>


    
        <div class="container">
            <div class="section">

                

                <!-- <p class="is-size-1">Server for Testing or Dev. Mode</p> -->
                <div class="row columns is-multiline">

                    <div class="column is-4"  v-for="news in newsArr" :key="news.id">

                        <LabNewsElementCard 
                        :news ="news"
                        />
                        <!-- <div class="card">
                            <header class="card-header">
                                <p class="card-header-title">{{ news.title }}</p>
                            </header>
                            <div class="card-image">
                                <figure class="image is-4by3" >
                                    <img :src="getImgUrl(news.id)" alt="Card image"   @click="viewNews(news.id)">
                                </figure>
                            </div>
                            <div class="card-content">
                               {{  `${news.descptoin_txt.substring(0, 200)}...`  }}
                            </div>
                            <footer class="card-footer">
                                <a href="#0" class="card-footer-item" @click="viewNews(news.id)"><i class="fas fa-fw fa-search"></i> View</a>
                                <a href="#0" class="card-footer-item" @click="editNews(news.id)"  v-if="userRoleFind(5)"><i class="fas fa-fw fa-edit"></i> Edit</a>
                            </footer>
                        </div> -->
                    </div>

                </div>
           
            </div>



            <!--  Recent Images Nonautomate Lab  -->
            <div v-show="CALL_FROM_VAR == 2 " >
                    <ImagesLABNonRecently 
                                v-if="imagesArrRecently.length>0 "
                                @showLab="showLab"
                                class="mb-5" 
                                    />
                    <section v-else>
                            <article class="media" v-for="i in mediaFake" :key="i">
                                <figure class="media-left">
                                    <p class="image is-64x64">
                                        <b-skeleton circle width="64px" height="64px"></b-skeleton>
                                    </p>
                                </figure>
                                <div class="media-content">
                                    <div class="content">
                                        <p>
                                            <b-skeleton active></b-skeleton>
                                            <b-skeleton height="80px"></b-skeleton>
                                        </p>
                                    </div>
                                    <nav class="level is-mobile">
                                        <div class="level-left">
                                            <a class="level-item">
                                                <span class="icon is-small">
                                                    <b-skeleton></b-skeleton>
                                                </span>
                                            </a>
                                            <a class="level-item">
                                                <span class="icon is-small">
                                                    <b-skeleton></b-skeleton>
                                                </span>
                                            </a>
                                        </div>
                                    </nav>
                                </div>
                            </article>
                    </section>   
            </div>
           

             <!--End  Recent Images Nonautomate Lab  -->  










            <!-- Last CBC Resulted Count/ 7 Days Lastest -->
            <div class="panel " v-if="fetchStatOfCBCLast7dayCompleted">
                <p class="panel-heading">
                    Last CBC Resulted
                </p>
                <div class="panel-block  " style="width: 100%">
                    <div class="container"  >
                        <LineChart ref="LineChart" :datacollection="datacollection"  :options="chartOptions"  />
                    </div>

                </div>
            </div>

            <section v-else>
                    <article class="media" v-for="i in mediaFake" :key="i">
                        <figure class="media-left">
                            <p class="image is-64x64">
                                <b-skeleton circle width="64px" height="64px"></b-skeleton>
                            </p>
                        </figure>
                        <div class="media-content">
                            <div class="content">
                                <p>
                                    <b-skeleton active></b-skeleton>
                                    <b-skeleton height="80px"></b-skeleton>
                                </p>
                            </div>
                            <nav class="level is-mobile">
                                <div class="level-left">
                                    <a class="level-item">
                                        <span class="icon is-small">
                                            <b-skeleton></b-skeleton>
                                        </span>
                                    </a>
                                    <a class="level-item">
                                        <span class="icon is-small">
                                            <b-skeleton></b-skeleton>
                                        </span>
                                    </a>
                                </div>
                            </nav>
                        </div>
                    </article>
            </section>   
            <!-- Last CBC Resulted Count/ 7 Days Lastest -->



            

            <!--  Recent Result Nonautomate Lab -->
            <div class="panel mt-5 "  v-if="listofcytoresultrecently.length>0">
                <div class="panel-heading">
                    <nav class="level is-mobile">
                        <div class="level-left">
                            <div class="level-item">
                                Recent Result Nonautomate Lab
                            </div>

                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <b-tooltip label="load more">
                                 <b-button type="is-primary" outlined v-show="listofcytoresultrecently.length>0"
                                  :disabled="isDisableMoreBtn"
                                  :loading="isMoreBtnLoading"
                                  @click="loadDataMore" >More..</b-button>
                                </b-tooltip>
                            </div>
                            <div class="level-item">
                                <b-tooltip label="Reload/Renew All Recent">
                                <b-button type="is-primary  is-light" outlined
                                          icon-right="refresh" @click="refreshRecently"/>
                                </b-tooltip>
                            </div>
                        </div>
                    </nav>
                </div>
                <div class="panel-block  ">


                    <b-tabs v-model="activeTab">
                        <b-tab-item label="All">
                        
                           <template #header>
                               <span :class="activeTab == 0 ?  'has-text-info has-text-weight-bold' : '' " >  All   <b-tag rounded class=""  :type="listofcytoresultrecently.length == 0 ? '' : 'is-primary'"> {{listofcytoresultrecently.length}} </b-tag> </span>
                           </template>
                            <div class="container">
                                <b-table

                                        :data="isEmpty ? [] : listofcytoresultrecently"
                                        bordered
                                        striped
                                        narrowed
                                        hoverable
                                        :loading="isTableLoading"
                                        focusable
                                        mobile-cards>


                                    <b-table-column   label="ID"  v-slot="props" >
 
                                        <b-button type="is-success" outlined @click="showLab({idlab:props.row.idlab , kind : props.row.kind , idopd : props.row.idopd })"> {{ props.row.idlab }}</b-button>
<!--                                        <b-button type="is-success" outlined @click="showLab(props.row.idlab,props.row.kind,props.row.idopd)">{{ props.row.idlab }}</b-button>-->
                                    </b-table-column>
                                    <b-table-column   label="OPD No." v-slot="props"  >
                                        {{ props.row.idopd }}
                                    </b-table-column>
                                    <b-table-column   label="Pet Name"  v-slot="props" >
                                        {{ props.row.opdname }}
                                    </b-table-column>
                                    <b-table-column   label="Owner"  v-slot="props" >
                                        {{ props.row.owner_name }}
                                    </b-table-column>
                                    <b-table-column   label="Gender" v-slot="props" >
                                          <span >
                                            <b-icon pack="fas" type="is-text"
                                                    :icon="props.row.sex === 'M' ? 'mars' : 'venus'">
                                            </b-icon>
                                          </span>
                                    </b-table-column>
                                    <b-table-column   label="Breed"  v-slot="props" >
                                        {{ props.row.breedname }}
                                    </b-table-column>
                                    <b-table-column   label="Species" v-slot="props"  >
                                        {{ props.row.speciesname }}
                                    </b-table-column>
                                    <b-table-column   label="Req. by" v-slot="props" >

                                        <!--                                    <figure class="image is-32x32" >-->
                                        <!--                                        <img :src="transFromAvartar( props.row.avartar_user_req , props.row.iduser_req) " />-->
                                        <!--                                    </figure>-->
                                        {{ props.row.user_req }}

                                    </b-table-column>
                                    <b-table-column   label="Date Req." v-slot="props"  >
                                        {{ props.row.date_req }}   {{ props.row.time_req }}
                                    </b-table-column>
                                    <b-table-column   label="Publish by" v-slot="props" >
                                        <!--                                    <figure class="image is-32x32" >-->
                                        <!--                                        <img :src="transFromAvartar( props.row.avartar_user_resulted , props.row.iduser_resulted) " />-->
                                        <!--                                    </figure>-->
                                        {{ props.row.user_resulted }}

                                    </b-table-column>
                                    <b-table-column   label="Date Publish" v-slot="props" >
                                        {{ props.row.date_resulted }} {{ props.row.time_resulted }}
                                    </b-table-column>



                                    <template slot="empty">
                                        <section class="section">
                                            <div class="content has-text-grey has-text-centered">
                                                <p>
                                                    <b-icon
                                                            icon="emoticon-sad"
                                                            size="is-large">
                                                    </b-icon>
                                                </p>
                                                <p>Nothing here.</p>
                                            </div>
                                        </section>
                                    </template>


                                    <template slot="footer"  >
                                        <div class="box">
                                            <div  class="level-right" >    <b-button type="is-primary" outlined 
                                                v-show="listofcytoresultrecently.length>0"    
                                                :isDisableMoreBtn="isDisableMoreBtn" 
                                                :isMoreBtnLoading="isMoreBtnLoading" 
                                                @click="loadDataMore" >More..</b-button></div>
                                        </div>
                                    </template>


                                </b-table>
                            </div>
                        </b-tab-item>

                        <b-tab-item label="Cytology">
                           <template #header>
                               <span :class="activeTab == 1 ?  'has-text-info has-text-weight-bold' : '' ">  Cytology <b-tag rounded  class="" :type="listofcytoresultrecentlyCytology.length == 0 ? ''  : 'is-primary'"> {{listofcytoresultrecentlyCytology.length}} </b-tag> </span>
                           </template>
                           <HomeEachKind
                                   :datasetToDisplay="listofcytoresultrecentlyCytology"
                                   :isDisableMoreBtn="isDisableMoreBtn"
                                   :isMoreBtnLoading="isMoreBtnLoading"
                                   @showLab="showLab"
                                   @loadDataMore="loadDataMore"/>
                        </b-tab-item>

                        <b-tab-item label="Biopsy">
                           <template #header>
                               <span :class="activeTab == 2 ?  'has-text-info has-text-weight-bold' : '' ">  Biopsy <b-tag rounded  class="" :type="listofcytoresultrecentlyBiopsy.length == 0 ? ''  : 'is-primary'" > {{listofcytoresultrecentlyBiopsy.length}} </b-tag> </span>
                           </template>
                            <HomeEachKind
                                    :datasetToDisplay="listofcytoresultrecentlyBiopsy"
                                    :disabled="isDisableMoreBtn"
                                    :loading="isMoreBtnLoading"
                                    @showLab="showLab"
                                    @loadDataMore="loadDataMore"/>
                        </b-tab-item>

                        <b-tab-item label="PCR">
                           <template #header>
                               <span :class="activeTab == 3 ?  'has-text-info has-text-weight-bold' : '' ">  PCR <b-tag rounded class="" :type="listofcytoresultrecentlyPCR.length == 0 ? ''  : 'is-primary'"  > {{listofcytoresultrecentlyPCR.length}} </b-tag> </span>
                           </template>
                            <HomeEachKind
                                    :datasetToDisplay="listofcytoresultrecentlyPCR"
                                    :isDisableMoreBtn="isDisableMoreBtn"
                                    :isMoreBtnLoading="isMoreBtnLoading"
                                    @showLab="showLab"
                                    @loadDataMore="loadDataMore"/>
                        </b-tab-item>

                        <b-tab-item label="Bacterial">
                            <template #header>
                               <span :class="activeTab == 4 ?  'has-text-info has-text-weight-bold' : '' ">  Bacterial <b-tag rounded  class="" :type="listofcytoresultrecentlyBacterial.length == 0 ? ''  : 'is-primary'" > {{listofcytoresultrecentlyBacterial.length}} </b-tag> </span>
                            </template>
                            <HomeEachKind
                                    :datasetToDisplay="listofcytoresultrecentlyBacterial"
                                    :isDisableMoreBtn="isDisableMoreBtn"
                                    :isMoreBtnLoading="isMoreBtnLoading"
                                    @showLab="showLab"
                                    @loadDataMore="loadDataMore"/>
                        </b-tab-item>

                        <b-tab-item label="Organism">
                            <template #header>
                               <span :class="activeTab == 5 ?  'has-text-info has-text-weight-bold' : '' ">  Organism <b-tag rounded class="" :type="listofcytoresultrecentlyOrganism.length == 0 ? ''  : 'is-primary'" > {{listofcytoresultrecentlyOrganism.length}} </b-tag> </span>
                            </template> 
                            <HomeEachKind
                                    :datasetToDisplay="listofcytoresultrecentlyOrganism"
                                    :isDisableMoreBtn="isDisableMoreBtn"
                                    :isMoreBtnLoading="isMoreBtnLoading"
                                    @showLab="showLab"
                                    @loadDataMore="loadDataMore"/>
                        </b-tab-item>


                        <b-tab-item label="Necropsy">
                            <template #header>
                               <span :class="activeTab == 6 ?  'has-text-info has-text-weight-bold' : '' " >  Necropsy <b-tag rounded class="" :type="listofcytoresultrecentlyNecropsy.length == 0 ? ''  : 'is-primary'"  > {{listofcytoresultrecentlyNecropsy.length}} </b-tag> </span>
                            </template> 
                            <HomeEachKind
                                    :datasetToDisplay="listofcytoresultrecentlyNecropsy"
                                    :isDisableMoreBtn="isDisableMoreBtn"
                                    :isMoreBtnLoading="isMoreBtnLoading"
                                    @showLab="showLab"
                                    @loadDataMore="loadDataMore"/>
                        </b-tab-item>


                        <b-tab-item label="Parasite">
                            <template #header>
                               <span :class="activeTab == 7 ?  'has-text-info has-text-weight-bold' : '' " >  Parasite <b-tag rounded class="" :type="listofcytoresultrecentlyParasite.length == 0 ? ''  : 'is-primary'" > {{listofcytoresultrecentlyParasite.length}} </b-tag> </span>
                            </template> 
                            <HomeEachKind
                                    :datasetToDisplay="listofcytoresultrecentlyParasite"
                                    :isDisableMoreBtn="isDisableMoreBtn"
                                    :isMoreBtnLoading="isMoreBtnLoading"
                                    @showLab="showLab"
                                    @loadDataMore="loadDataMore"/>
                        </b-tab-item>



                    </b-tabs>

                </div>
            </div>


            <section v-else>
                    <article class="media" v-for="i in mediaFake" :key="i">
                        <figure class="media-left">
                            <p class="image is-64x64">
                                <b-skeleton circle width="64px" height="64px"></b-skeleton>
                            </p>
                        </figure>
                        <div class="media-content">
                            <div class="content">
                                <p>
                                    <b-skeleton active></b-skeleton>
                                    <b-skeleton height="80px"></b-skeleton>
                                </p>
                            </div>
                            <nav class="level is-mobile">
                                <div class="level-left">
                                    <a class="level-item">
                                        <span class="icon is-small">
                                            <b-skeleton></b-skeleton>
                                        </span>
                                    </a>
                                    <a class="level-item">
                                        <span class="icon is-small">
                                            <b-skeleton></b-skeleton>
                                        </span>
                                    </a>
                                </div>
                            </nav>
                        </div>
                    </article>
            </section>

            <!-- End Recent Result Nonautomate Lab --> 









            <div class="panel mb-5">

               
            </div>



        </div>






<!--    <ViewNonAutoMateDialog     ref="ViewNonAutoMateDialog" />-->
      <ViewNews ref="ViewNews" :datNews="datNews"/>
      <EditNews  ref="EditNews" :datNews="datNews" @closeModalWithChange="closeModalWithChange"/>



    </div>






</template>


<script>
    /* eslint-disable no-console */
    // import { checkAccessTokenWithFpValid } from '@/utils.js'
    // import 'vue-select/dist/vue-select.css';
   import LineChart from "./Chart/LineChartComp";
   import axios from "axios";
   import { getBaseURLforBackEnd  , getConfigAxios , getBaseURLAvartar ,getBaseURLLabNews,CALL_FROM,}  from '@/utils.js'
   import {mapActions, mapMutations, mapState} from "vuex";
   import ViewNews from "./News/ViewNews";
   import EditNews from "./News/EditNews";
   import userRoleFind from "../mixins/methods/userRoleFind";
   import HomeEachKind from "./HomeEachKind";
   import ImagesLABNonRecently from './ImagesLABNonRecently.vue'

   import LabNewsElementCard from './NewsV2/LabNewsElementCard.vue'


 

export default {
    name : 'Home',
    components : {
        LineChart,
        ViewNews,
        EditNews,
        HomeEachKind,
        ImagesLABNonRecently,
        LabNewsElementCard,
    },

    mixins:[userRoleFind],
    created() {
        // this.datacollection =  {
        //     labels: this.dateStatOfCBCLast7Day,
        //         datasets: [{
        //         "backgroundColor": 'rgba(0, 150, 0, 0.1)',
        //         "data":  this.dataStatOfCBCLast7Day
        //     }]
        // }
        // console.log(this.dateStatOfCBCLast7Day)
        // console.log(this.dataStatOfCBCLast7Day)
        //
        // this.$refs.LineChart.datacollection =
        //     {
        //         labels: this.dateStatOfCBCLast7Day,
        //         datasets: [{
        //             "backgroundColor": 'rgba(0, 150, 0, 0.1)',
        //             "data": this.dataStatOfCBCLast7Day
        //         }]
        //     }
        // this.$refs.LineChart.options = {
        //     onClick: this.lineChartClick,
        //
        //     legend : false,
        //     responsive: true,
        //     maintainAspectRatio: false,
        //     tooltips: {
        //         mode : 'nearest',
        //         intersect : false,
        //         onClick: this.tooltipsClick
        //     }
        // }
    },
    beforeCreate() {
          // this.$refs.LineChart.datacollection =
          //           {
          //               labels: this.dateStatOfCBCLast7Day,
          //               datasets: [{
          //                   "backgroundColor": 'rgba(0, 150, 0, 0.1)',
          //                   "data": this.dataStatOfCBCLast7Day
          //               }]
          //           }
          //       this.$refs.LineChart.options = {
          //           onClick: this.lineChartClick,
          //
          //           legend : false,
          //           responsive: true,
          //           maintainAspectRatio: false,
          //           tooltips: {
          //               mode : 'nearest',
          //               intersect : false,
          //               onClick: this.tooltipsClick
          //           }
          //       }

        // const vm = this
        // axios.post(`${getBaseURLforBackEnd()}/api/statofcbclast7day` , getConfigAxios())
        //     .then((res) => {
        //         vm.statofcbclast7day = res.data
        //         // console.log("this.statofcbclast7day")
        //         // console.log(res.data)
        //
        //         vm.$refs.LineChart.datacollection =
        //             {
        //                 labels: vm.dateStatOfCBCLast7Day,
        //                 datasets: [{
        //                     "backgroundColor": 'rgba(0, 150, 0, 0.1)',
        //                     "data": vm.dataStatOfCBCLast7Day
        //                 }]
        //             }
        //         vm.$refs.LineChart.options = {
        //             onClick: vm.lineChartClick,
        //
        //             legend : false,
        //             responsive: true,
        //             maintainAspectRatio: false,
        //             tooltips: {
        //                 mode : 'nearest',
        //                 intersect : false,
        //                 onClick: this.tooltipsClick
        //             }
        //         }
        //
        //
        //     })
    },
    mounted() {
        this.fetchNewsArr()

        // this.fetchListOfCytoresultRecently({"first":this.first,"skip":this.skip})
        // this.loadNonAutomateRecently()
        this.datacollection =  {
            labels: this.dateStatOfCBCLast7Day,
            datasets: [{
                "backgroundColor": 'rgba(0, 150, 0, 0.1)',
                "data":  this.dataStatOfCBCLast7Day
            }]
        }
    },
    computed:{
        ...mapState({
            user_id : state => state.master_data.user_id ,
            clientIP : state => state.master_data.clientIP ,
            counterTest: state => state.master_data.counterTest ,
            listofcytoresultrecently : state => state.home.listofcytoresultrecently ,
            first: state => state.home.first,
            skip : state => state.home.skip ,
            step: state => state.home.step ,
            statofcbclast7day: state => state.home.statofcbclast7day ,
            fetchStatOfCBCLast7dayCompleted: state => state.home.fetchStatOfCBCLast7dayCompleted ,
            newsArr: state => state.home.newsArr ,
            user_role: state => state.master_data.user_role ,
            fingerPrint : state => state.master_data.fingerPrint,

            imagesArrRecently : state => state.home.imagesArrRecently ,

            

        }),
       
        dateStatOfCBCLast7Day: function () {
               return this.statofcbclast7day.map((dat)=>{
                   // console.log(dat.data_report)
                  return dat.data_report
               })
        },
        dataStatOfCBCLast7Day: function () {
            return this.statofcbclast7day.map((dat) => {
                return dat.count
            })
        },
        listofcytoresultrecentlyCytology: function () {
               return this.listofcytoresultrecently.filter(dat=>{
                   return dat.kind.toUpperCase()==='CYTOLOGY'
               })
        },

        listofcytoresultrecentlyBiopsy: function () {
            return this.listofcytoresultrecently.filter(dat=>{
                return dat.kind.toUpperCase()==='BIOPSY'
            })
        },
        listofcytoresultrecentlyPCR: function () {
            return this.listofcytoresultrecently.filter(dat=>{
                return dat.kind.toUpperCase()==='PCR'
            })
        },
        listofcytoresultrecentlyBacterial: function () {
            return this.listofcytoresultrecently.filter(dat=>{
                return dat.kind.toUpperCase()==='BACTERIAL'
            })
        },
        listofcytoresultrecentlyOrganism: function () {
            return this.listofcytoresultrecently.filter(dat=>{
                return dat.kind.toUpperCase()==='ORGANISM'
            })
        },

        listofcytoresultrecentlyNecropsy: function () {
            return this.listofcytoresultrecently.filter(dat=>{
                return dat.kind.toUpperCase()==='NECROPSY'
            })
        },


        listofcytoresultrecentlyParasite: function () {
            return this.listofcytoresultrecently.filter(dat=>{
                return dat.kind.toUpperCase()==='PARASITE'
            })
        },

        CALL_FROM_VAR(){
            return CALL_FROM
        }
    },
    methods:{
        ...mapActions({
            setupIDLABTarget : 'lab_target/setupIDLABTarget',
            setupIDOPDTarget : 'opd_target/setupIDOPDTarget',
            produceSetCounterTest: 'master_data/produceSetCounterTest',
            produceSkip : 'home/produceSkip',
            fetchListOfCytoresultRecently : 'home/fetchListOfCytoresultRecently',
            clearListOfCytoResultRecently: 'home/clearListOfCytoResultRecently',
            fetchNewsArr : 'home/fetchNewsArr'
        }),
        ...mapMutations({
        //    setFlagWantViewLabByHome : 'worklist/setFlagWantViewLabByHome'
        }),

    //   async  testSmartCardReader(){
    //            console.log('---> testSmartCardReader');

    //              try {
    //                     let response = await fetch("http://127.0.0.1:8899/getdata");
    //                     let data = await response.json();
    //                     if (data.length == 1) {
    //                       console.log(  data[0]  )
    //                     }else{
    //                         console.log("some error occur");  
    //                     }
                        
    //                 } catch (error) {
    //                     console.log(error);
    //                 }
 

    //   },

     




      refreshRecently(){
            this.isTableLoading = true
            const vm = this
            this.produceSkip(0)
            this.clearListOfCytoResultRecently()
              .then(()=>{
                  vm.fetchListOfCytoresultRecently({"first":this.first,"skip":this.skip})
                  .then(()=>{
                      vm.isTableLoading = false
                  })
              })
              .catch(()=>{
                      vm.isTableLoading = false
              })



      },
      checkVuex(){
            // console.log(this.fingerPrint)
      },
      openTemptest(){
          // window.open('http://192.168.1.34:8080/temptest', '_blank');
      },
      closeModalWithChange(){
          this.fetchNewsArr()
      },
      editNews(id){

          const tmp =  this.newsArr.find(dat => {
              return dat.id === id
          })
          const tmp1 = {
              "id": tmp.id ,
              "title": tmp.title ,
              "images": tmp.images,
              "descptoin_html": tmp.descptoin_html,
              "descptoin_txt": tmp.descptoin_txt,
              "user_rec": tmp.user_rec,
              "user_rec_id": tmp.user_rec_id,
              "date_rec": tmp.date_rec,
              "time_rec": tmp.time_rec ,
              "avartar_path": tmp.avartar_path,
              "image_fresh" : false , // new params
              "urlTempUploaded": ''   // new params
          }
          this.$refs.EditNews.datEditNews = tmp1
          // clear var
          this.$refs.EditNews.urlTempUploaded = ''
          // wake up
          this.$refs.EditNews.isComponentModalActive = true



      },
      viewNews(id){
             const tmp =  this.newsArr.find(dat => {
                return dat.id === id
             })
            this.datNews = tmp
            this.$refs.ViewNews.isComponentModalActive = true
      },
      getImgUrl(id) {
            const tmp =  this.newsArr.find(dat => {
                return dat.id === id
            })

          return `${getBaseURLLabNews()}/${tmp.images}`
            // return `https://picsum.photos/id/43${id}/1230/500`
        },
      async  showLab(payload){
           // payload ={"idlab":idlab , "kind" : kind , "idopd" : idopd }
            // console.log(JSON.stringify(payload))
            if(this.user_id !== null) {

                        const tmpcounterTest = 1
                        this.produceSetCounterTest(tmpcounterTest)


                        const datTo = {
                            "idopd": payload.idopd,
                            "user": this.user_id,
                            "ip": this.clientIP
                        }
                        const vm = this


                          await axios.post(`${getBaseURLforBackEnd()}/api/opdinfo_by_hn`, datTo, getConfigAxios())
                            .then(res => {
                             
                                     
                                    vm.setupIDOPDTarget({
                                        "idopd": res.data.idopd,
                                        "idlab": "",
                                        "opdname": res.data.name,
                                        "type": res.data.species + '(' + res.data.breed + ')',
                                        "owner_name": res.data.owner_name,
                                        "status": "",
                                        "gender": res.data.sex,
                                        "age": res.data.age,
                                        "kind": "",
                                        "automate": "",
                                        "datereq": "",
                                        "timereq": "",
                                        "reqby": "",
                                        "dateaccept": "",
                                        "timeaccept": "",
                                        "acceptby": "",
                                        "datecancle": "",
                                        "timecancle": "",
                                        "cancleby": "",
                                        "datereject": "",
                                        "timereject": "",
                                        "rejectby": "",
                                        "dateresult": "",
                                        "timeresult": "",
                                        "resultby": ""
                                    })
                                 


                                }
                            )
                          this.setupIDLABTarget({"idlab": payload.idlab, "kind": payload.kind}) 
                              .then(()=>{
                                // this.setFlagWantViewLabByHome(true)
                                this.$router.push('/worklist' ) 
                              })
                           
                           




                      
                        // await axios.post(`${getBaseURLforBackEnd()}/api/opdinfo_by_hn`, datTo, getConfigAxios())
                        //     .then(res => {
                        //         //    console.log(JSON.stringify( res.data ))
                        //             vm.OPDSelected = {
                        //                 "idopd": res.data.idopd,
                        //                 "idlab": "",
                        //                 "opdname": res.data.name,
                        //                 "type": res.data.species + '(' + res.data.breed + ')',
                        //                 "owner_name": res.data.owner_name,
                        //                 "status": "",
                        //                 "gender": res.data.sex,
                        //                 "age": res.data.age,
                        //                 "kind": "",
                        //                 "automate": "",
                        //                 "datereq": "",
                        //                 "timereq": "",
                        //                 "reqby": "",
                        //                 "dateaccept": "",
                        //                 "timeaccept": "",
                        //                 "acceptby": "",
                        //                 "datecancle": "",
                        //                 "timecancle": "",
                        //                 "cancleby": "",
                        //                 "datereject": "",
                        //                 "timereject": "",
                        //                 "rejectby": "",
                        //                 "dateresult": "",
                        //                 "timeresult": "",
                        //                 "resultby": ""
                        //             }
                        //             vm.setupIDOPDTarget(vm.OPDSelected)
                        //             .then(()=>{
                        //                 // console.log('payload.kind--->  ',payload.kind)
                        //                 vm.setupIDLABTarget({"idlab": payload.idlab, "kind": payload.kind})
                        //                     .then(()=>{
                        //                         vm.$router.push('/worklist' ) 
                        //                         .then(()=>{
                        //                             // console.log("push router completed")
                        //                             // this.$nextTick(function () {
                        //                             //                          vm.setFlagWantViewLabByHome(vm.flagWantViewLabByHome+1)
                        //                             //                         // console.log("push router completed I")
                        //                             //                 });
                        //                         })
                        //                         .catch(()=>{})


                        //                         // vm.$router.push('/worklist',()=>{
                        //                         //        console.log('push /worklist')
                        //                         // })
                        //                         //     .catch(()=>{});

                        //                     })
                        //             })


                        //         }
                        //     )
                        //     .catch((err) => {
                        //         if (err.response && err.response.status === 401) {
                        //             vm.$router.push('/login')
                        //         }
                        //     })
                        //     .finally(() => {

                        //     })


            }else{
                this.$router.push('/login')
                    .catch(()=>{});
            }


      },
      transFromAvartar(avatar,iduser){
           return  `${getBaseURLAvartar()}/user_${iduser}/${avatar} `
        },
      loadDataMore(){
            const tmpSkip = this.skip + this.step
            this.produceSkip( tmpSkip )
            this.isDisableMoreBtn = true
            this.isMoreBtnLoading = true
            this.fetchListOfCytoresultRecently()
                .then(()=>{
                        // console.log("fetchListOfCytoresultRecently")
                        this.$buefy.toast.open({
                        duration: 800,
                        message: `fetch data completed`,
                        position: 'is-bottom-right',
                        type: 'is-success'
                        })
                        this.isDisableMoreBtn = false
                        this.isMoreBtnLoading = false
                }) 

        },



    },
    watch : {
        openTemptest: {
            handler:function (val) {
              console.log(val)
            }
        },
        dateStatOfCBCLast7Day: {
            handler: function (val) {
               if(val) {
                       this.datacollection =  {
                       labels: this.dateStatOfCBCLast7Day,
                       datasets: [{
                           "backgroundColor": 'rgba(0, 150, 0, 0.1)',
                           "data":  this.dataStatOfCBCLast7Day
                       }]
                   }
               }
            }
        }
    }    ,
    data() {
        return {
            //
            isMoreBtnLoading : false,
            isDisableMoreBtn : false,
            //

            isTableLoading : false,
            //
            activeTab : 0,


            IDLABSelected : {"idlab": "","kind": ""}  ,
            OPDSelected : {},


            isEmpty : false,
            // statofcbclast7day: [],


            datNews : {},

            datacollection:  {
                labels:  [ "22-Nov-2019", "21-Nov-2019", "20-Nov-2019", "19-Nov-2019", "18-Nov-2019", "17-Nov-2019", "16-Nov-2019", "15-Nov-2019", "14-Nov-2019", "13-Nov-2019", "12-Nov-2019" ],
                datasets: [{
                    "backgroundColor": 'rgba(0, 150, 0, 0.1)',
                    "data":  [ 275, 234, 317, 280, 242, 246, 269, 213, 316, 323, 394 ]
                }]
            },

            chartOptions: {
                onClick: this.lineChartClick,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                },
                legend: false,
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    mode: 'nearest',
                    intersect: false,
                    onClick: this.tooltipsClick
                }
            },
            // options : [  { 'id':1, 'name':'Canada'} ,
            //              { 'id':2, 'name':'Thailand'} ,
            //              { 'id':3, 'name':'Switzerland'} ,
            //           ],
            mediaFake : 3,




             someArr:   [
                            { name: 'John', age: 25, country: 'USA' },
                            { name: 'Emily', age: 30, country: 'UK' },
                            { name: 'James', age: 22, country: 'Canada' }
                        ],

        }
    }
}
</script>

<style scoped>

    #datetime-card {
        color:  dodgerblue ;
        font-size: 12px;
    }

    img{
        cursor: pointer;
        width:100%;
        height:100%;
        object-fit: contain;
    }

</style>